// ===== MARQUEE EFFECT =====
(function () {
  const SECTIONS = [
    { id: 'multicolumn_Uw7cHh', direction: 'left' },
    { id: 'multicolumn_cFG8iD', direction: 'right' },
    { id: 'multicolumn_4thhrM', direction: 'left' },
  ];

  function initMarquee() {
    SECTIONS.forEach(({ id, direction }) => {
      const section = document.getElementById(id);
      if (!section) return;

      const list = section.querySelector('.multicolumn-list');
      if (!list) return;

      // Wrap list in marquee containers
      const wrap = document.createElement('div');
      wrap.className = `pinets-marquee-wrap pinets-marquee--${direction}`;

      const track = document.createElement('div');
      track.className = 'pinets-marquee-track';

      // Clone items for seamless loop
      const clone = list.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');

      track.appendChild(list.cloneNode(true));
      track.appendChild(clone);

      wrap.appendChild(track);

      // Replace original list with marquee
      list.parentNode.replaceChild(wrap, list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarquee);
  } else {
    initMarquee();
  }
})();
